import React from 'react'
import { Helmet } from 'react-helmet-async'

import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'

import { Box, Button, Columns } from '@domain-group/suit-theme'

import PageHeader from '@components/PageHeader'

import { UsePortalPayload } from '@hooks/usePortal'

import generateTabBarItems from '../../utils/generateTabBarItems'

interface PageLayoutProps {
  activeTabBarItemKey: string,
  children: React.ReactNode,
  entityPayload: UsePortalPayload,
}

const PageLayout = (props: PageLayoutProps) => {
  const { activeTabBarItemKey, children, entityPayload } = props

  const {
    portal,
    urls: { portalsIndexUrl },
  } = entityPayload

  const { redirect }: { redirect?: string } = parsePermittedQueryParams(getQueryParamsFromHash(), ['redirect'])

  return (
    <>
      <Helmet>
        <title>Portals | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button
            // @ts-expect-error TS2322
            as="a"
            buttonStyle="secondaryUtility"
            href={redirect || portalsIndexUrl}
            size="medium"
            width="auto"
          >
            Back
          </Button>
        )}
        activeTabBarItemKey={activeTabBarItemKey}
        // @ts-expect-error TS2345
        tabBarItems={generateTabBarItems(portal)}
        title="Edit Portal"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          {children}
        </Columns>
      </Box>
    </>
  )
}

export default PageLayout
